"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lastStep = exports.isTouristsStep = exports.isPopularCountriesStep = exports.isMetaregionsStep = exports.isEqualPreviousSearches = exports.isDestinationStep = exports.isDepartureStep = exports.isDatepickerStep = exports.getTrackerParams = exports.getSearchParamsChanges = exports.convertNightsIntervalToString = exports.convertNightsIntervalToPreset = exports.convertLatinToRus = exports.convertDatesToStringWithEllipsis = exports.convertDatePickerParamsToStrings = exports.convertCalendarDatesToNightsInterval = exports.convertCalendarDateToPreset = exports.afterDestinationStep = exports.afterDepartureStep = exports.afterDatepickerStep = void 0;

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _last2 = _interopRequireDefault(require("lodash/last"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _date = require("@lt/components/utils/date");

var _utils = require("./components/DatePicker/components/Calendar/utils");

var _utils2 = require("../../utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var lastStep = function lastStep(steps) {
  return (0, _last2["default"])(steps);
};

exports.lastStep = lastStep;

var isDestinationStep = function isDestinationStep(steps) {
  return lastStep(steps) === _constants.FIELD_NAMES.destination;
};

exports.isDestinationStep = isDestinationStep;

var afterDestinationStep = function afterDestinationStep(steps) {
  return steps.includes(_constants.FIELD_NAMES.destination);
};

exports.afterDestinationStep = afterDestinationStep;

var isDepartureStep = function isDepartureStep(steps) {
  return lastStep(steps) === _constants.FIELD_NAMES.departure;
};

exports.isDepartureStep = isDepartureStep;

var isDatepickerStep = function isDatepickerStep(steps) {
  return lastStep(steps) === _constants.FIELD_NAMES.datepicker;
};

exports.isDatepickerStep = isDatepickerStep;

var afterDepartureStep = function afterDepartureStep(steps) {
  return steps.includes(_constants.FIELD_NAMES.departure);
};

exports.afterDepartureStep = afterDepartureStep;

var isPopularCountriesStep = function isPopularCountriesStep(steps) {
  return lastStep(steps) === _constants.FIELD_NAMES.popularCountries;
};

exports.isPopularCountriesStep = isPopularCountriesStep;

var isMetaregionsStep = function isMetaregionsStep(steps) {
  return lastStep(steps) === _constants.FIELD_NAMES.metaregions;
};

exports.isMetaregionsStep = isMetaregionsStep;

var afterDatepickerStep = function afterDatepickerStep(steps) {
  return steps.includes(_constants.FIELD_NAMES.datepicker);
};

exports.afterDatepickerStep = afterDatepickerStep;

var isTouristsStep = function isTouristsStep(steps) {
  return lastStep(steps) === _constants.FIELD_NAMES.tourists;
};

exports.isTouristsStep = isTouristsStep;

var convertDatesToStringWithEllipsis = function convertDatesToStringWithEllipsis(dateCell, isShort) {
  if (!(dateCell !== null && dateCell !== void 0 && dateCell.date)) return '';
  var date = dateCell.date;
  var formatToken = isShort ? 'd MMM' : 'd MMMM';
  return (0, _date.formatDate)(date, formatToken);
};

exports.convertDatesToStringWithEllipsis = convertDatesToStringWithEllipsis;

var convertCalendarDateToPreset = function convertCalendarDateToPreset(dateCell, shift) {
  if (!(dateCell !== null && dateCell !== void 0 && dateCell.date) || !shift) {
    return null;
  }

  var date = dateCell.date;
  var isShortTitle = !!shift;
  var title = convertDatesToStringWithEllipsis(dateCell, isShortTitle);
  var from = (0, _addDays["default"])(date, -shift);
  var to = (0, _addDays["default"])(date, shift);
  return {
    name: 'calendar_date',
    title: title,
    value: {
      from: from,
      to: to
    }
  };
};

exports.convertCalendarDateToPreset = convertCalendarDateToPreset;

var convertNightsIntervalToString = function convertNightsIntervalToString(nightsInterval) {
  var from = nightsInterval.from,
      to = nightsInterval.to;
  var nightsString = "".concat(from === to ? '' : "".concat(from, "...")).concat(to, " ").concat((0, _utils2.pluralizeNights)(to));
  return nightsString;
};

exports.convertNightsIntervalToString = convertNightsIntervalToString;

var convertNightsIntervalToPreset = function convertNightsIntervalToPreset(nightsInterval) {
  if (!nightsInterval) {
    return;
  }

  return {
    name: 'nights_interval',
    title: convertNightsIntervalToString(nightsInterval),
    value: nightsInterval
  };
};

exports.convertNightsIntervalToPreset = convertNightsIntervalToPreset;

var convertCalendarDatesToNightsInterval = function convertCalendarDatesToNightsInterval(_ref) {
  var startDateCell = _ref.startDateCell,
      endDateCell = _ref.endDateCell;
  return (0, _utils.getRangeNightsString)({
    startDateCell: startDateCell,
    endDateCell: endDateCell
  });
};

exports.convertCalendarDatesToNightsInterval = convertCalendarDatesToNightsInterval;

var convertDatePickerParamsToStrings = function convertDatePickerParamsToStrings(_ref2) {
  var leftValue = _ref2.leftValue,
      rightValue = _ref2.rightValue,
      startDatePreset = _ref2.startDatePreset,
      nights = _ref2.nights,
      nightsPreset = _ref2.nightsPreset;
  var isPreset = !!(startDatePreset || nights || nightsPreset);
  var leftDateString = convertDatesToStringWithEllipsis(leftValue);
  var rightDateString = convertDatesToStringWithEllipsis(rightValue);
  var startDateOrPreset = leftDateString || (startDatePreset === null || startDatePreset === void 0 ? void 0 : startDatePreset.title) || '';
  var nightsString = nights ? "\u041D\u0430 ".concat(convertNightsIntervalToString(nights)) : '';
  var endDateOrDuration = rightDateString || (nightsPreset === null || nightsPreset === void 0 ? void 0 : nightsPreset.title) || nightsString;
  return {
    isPreset: isPreset,
    left: startDateOrPreset,
    right: endDateOrDuration
  };
};

exports.convertDatePickerParamsToStrings = convertDatePickerParamsToStrings;

var isEqualPreviousSearches = function isEqualPreviousSearches(s1, s2) {
  var _s1$departure, _s2$departure;

  var destinationEqual = s1.destination.value === s2.destination.value;
  var s1Start = (0, _utils.getCornerDates)({
    date: s1.datepicker.left.date,
    shift: s1.datepicker.shift
  });
  var s1End = (0, _utils.getCornerDates)({
    date: s1.datepicker.right.date,
    shift: s1.datepicker.shift
  });
  var s2Start = (0, _utils.getCornerDates)({
    date: s2.datepicker.left.date,
    shift: s2.datepicker.shift
  });
  var s2End = (0, _utils.getCornerDates)({
    date: s2.datepicker.right.date,
    shift: s2.datepicker.shift
  });
  var datepickerEqual = (0, _isEqual2["default"])(s1Start, s2Start) && (0, _isEqual2["default"])(s1End, s2End);
  var touristEqual = (0, _isEqual2["default"])(s1.tourists, s2.tourists);
  var departureEqual = ((_s1$departure = s1.departure) === null || _s1$departure === void 0 ? void 0 : _s1$departure.value) === ((_s2$departure = s2.departure) === null || _s2$departure === void 0 ? void 0 : _s2$departure.value);
  return destinationEqual && datepickerEqual && touristEqual && departureEqual;
};

exports.isEqualPreviousSearches = isEqualPreviousSearches;

var convertLatinToRus = function convertLatinToRus(str) {
  return str.toLowerCase().split('').map(function (sym) {
    return _constants.enToRusKeyboardMap.get(sym) || sym;
  }).join('');
};

exports.convertLatinToRus = convertLatinToRus;

var getSearchParamsChanges = function getSearchParamsChanges(lhs, rhs) {
  var changes = Object.keys(lhs).reduce(function (res, cur) {
    if (!(0, _isEqual2["default"])(lhs[cur], rhs[cur])) {
      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, cur, rhs[cur]));
    }

    return res;
  }, {});
  return changes;
}; // Для формирования параметров события сабмита сигареты


exports.getSearchParamsChanges = getSearchParamsChanges;

var getDatesRangeType = function getDatesRangeType(datepicker) {
  var nightsPreset = datepicker.nightsPreset,
      nights = datepicker.nights;

  if (nightsPreset) {
    return 'preset';
  }

  if (nights) {
    return 'nights';
  }

  return 'calendar';
};

var getNightsTrackerParams = function getNightsTrackerParams(datepicker) {
  var nights = datepicker.nights,
      nightsPreset = datepicker.nightsPreset,
      left = datepicker.left,
      right = datepicker.right;
  var preparedNights = nights || (nightsPreset === null || nightsPreset === void 0 ? void 0 : nightsPreset.value) || convertCalendarDatesToNightsInterval({
    startDateCell: left,
    endDateCell: right
  });
  return {
    nights_from: preparedNights.from,
    nights_to: preparedNights.to,
    nights_preset: (nightsPreset === null || nightsPreset === void 0 ? void 0 : nightsPreset.name) || null
  };
};

var getStartDateTrackerParams = function getStartDateTrackerParams(_ref3) {
  var _datepicker$startDate, _datepicker$startDate2;

  var datepicker = _ref3.datepicker,
      landParams = _ref3.landParams;
  var startDatePresetValue = (_datepicker$startDate = datepicker.startDatePreset) === null || _datepicker$startDate === void 0 ? void 0 : _datepicker$startDate.value;
  var startDatePresetTrackerParams = startDatePresetValue ? {
    start_date_from: (0, _utils2.formatServerDate)(new Date(startDatePresetValue.from)),
    start_date_till: (0, _utils2.formatServerDate)(new Date(startDatePresetValue.to))
  } : undefined;
  var startDateTrackerParams = (0, _pick2["default"])(landParams, ['start_date_from', 'start_date_till']);
  return _objectSpread(_objectSpread(_objectSpread({}, startDateTrackerParams), startDatePresetTrackerParams), {}, {
    start_date_preset: ((_datepicker$startDate2 = datepicker.startDatePreset) === null || _datepicker$startDate2 === void 0 ? void 0 : _datepicker$startDate2.name) || null
  });
};

var getKidsAgesTrackerParam = function getKidsAgesTrackerParam(values) {
  return values.tourists.kids.join('|');
};

var getTrackerParamsFromValues = function getTrackerParamsFromValues(values) {
  var departure = values.departure,
      destination = values.destination,
      datepicker = values.datepicker;
  if (!departure || !destination || !datepicker) return;
  var initialTab = datepicker.initialTab,
      buttonsClicked = datepicker.buttonsClicked;
  var isCountryDestination = ['countries', 'allCountries', 'popularCountries'].includes(destination.groupName);
  return _objectSpread(_objectSpread({
    departure_id: departure.id,
    departure_name: departure.value,
    country_id: isCountryDestination && destination.value || null,
    country_iso2: destination.iso2 || null,
    to_place_id: !isCountryDestination && destination.value || 0,
    dates_range_type: getDatesRangeType(datepicker),
    kids_ages: getKidsAgesTrackerParam(values)
  }, getNightsTrackerParams(datepicker)), {}, {
    initial_tab: initialTab || 'calendar',
    buttons_clicked: [buttonsClicked || []].join('|')
  });
};

var getTrackerParamsFromLandParams = function getTrackerParamsFromLandParams(landParams) {
  var adults = landParams.adults,
      kids = landParams.kids;
  return _objectSpread(_objectSpread({}, (0, _pick2["default"])(landParams, ['end_date_from', 'end_date_till', 'search_type'])), {}, {
    adults_count: adults,
    kids_count: kids
  });
};

var getTrackerParams = function getTrackerParams(_ref4) {
  var _datepicker$nightsPre;

  var values = _ref4.values,
      landParams = _ref4.landParams;
  var datepicker = values.datepicker;
  if (!datepicker) return;
  var trackerParamsFromValues = getTrackerParamsFromValues(values);
  if (!trackerParamsFromValues) return;
  var trackerParamsFromLandParams = getTrackerParamsFromLandParams(landParams);

  var trackerParams = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _constants.DEFAULT_TRACKER_PARAMS), trackerParamsFromValues), trackerParamsFromLandParams), getStartDateTrackerParams({
    datepicker: datepicker,
    landParams: landParams
  })), {}, {
    default_nights_preset: ((_datepicker$nightsPre = datepicker.nightsPreset) === null || _datepicker$nightsPre === void 0 ? void 0 : _datepicker$nightsPre.recommended) || false
  });

  return trackerParams;
};

exports.getTrackerParams = getTrackerParams;